import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useApi, errMsg } from "@/lib/api";

export default function DeleteOrderButton({ order, onDeleted }) {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const remove = async () => {
    setBusy(true);
    try {
      await api("delete", `/admin/orders/${order.id}`);
      toast.success(`Pesanan ${order.order_code} dihapus`);
      onDeleted();
    } catch (e) { toast.error(errMsg(e, "Gagal menghapus")); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button data-testid="delete-order-btn" className="inline-flex items-center gap-1.5 text-red-400 border border-red-500/40 hover:bg-red-500/10 px-3 py-1 text-xs font-semibold uppercase transition-colors">
          <Trash2 className="w-3 h-3" /> Hapus Pesanan
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-[#0d0d0d] border-white/10 rounded-none" data-testid="delete-order-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display uppercase text-2xl">Hapus pesanan {order.order_code}?</AlertDialogTitle>
          <AlertDialogDescription>Pesanan atas nama {order.athlete_name} akan dihapus permanen dari daftar, rekap, dan ekspor Excel. Link kuitansinya juga tidak bisa dibuka lagi.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-order-cancel-btn" className="rounded-none">Batal</AlertDialogCancel>
          <AlertDialogAction onClick={remove} disabled={busy} data-testid="delete-order-confirm-btn" className="rounded-none bg-red-700 hover:bg-red-600 text-white">
            {busy && <Loader2 className="w-4 h-4 animate-spin mr-1" />} Ya, Hapus
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
